import { render } from "./HomePage.vue?vue&type=template&id=ca70ec78"
const script = {}

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__